import { displayNames } from "../constants/bucketed_audience_size";
import get from "lodash/get";
import find from "lodash/find";

export function formatAudienceSize(sizeKey) {
  var size = find(displayNames, size => sizeKey === size.value);
  return get(size, "name", "Calculating");
}
